import React from "react";

export default function Loader() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src="/img/logo/logo.png" alt="loader" style={{width:'200px'}}/>
      <span className="loader"></span>
    </div>
  );
}
